// extracted by mini-css-extract-plugin
export default {"error":"styles_error__O1gBZ","btn":"styles_btn__XbG68"};